var React = require('react');

function Mars (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.634 5v2.112h3.21l-4.5 4.5c-3.673-2.886-8.987-2.418-12.094 1.074-3.114 3.499-2.955 8.844.357 12.157 3.313 3.312 8.658 3.47 12.157.357 3.491-3.108 3.96-8.421 1.073-12.095l4.5-4.5v3.211h2.113V5h-6.816zm-7.353 6.849a6.735 6.735 0 014.759 1.426l1.135 1.135v.001a6.735 6.735 0 01-.815 9.211 6.735 6.735 0 01-9.26-.272 6.735 6.735 0 01-.273-9.26 6.729 6.729 0 014.454-2.241z"}));
}

Mars.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Mars;

Mars.default = Mars;
